export default __webpack_public_path__ + "static/food-cutting-logo-small-035d7f886ac5495a5c7b7a67c63dcffd.svg";